import * as localeDictionary from 'plotly.js/lib/locales/fr';
import React, { useMemo } from 'react';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';

const GaugeDemiCercle = ({
  donnees,
  viewobj_json_content,
  dimensionWidth,
  dimensionHeight,
  configuration,
  donneesGraphe,
  switchAfficherModifierIntervalle,
}) => {
  // Memoized data processing
  const { value, unit, color, maxValue, minValue } = useMemo(() => {
    let currentValue, currentUnit, currentLabel, currentColor;
    let maxVal, minVal;

    for (const courbe of donnees) {
      if (courbe.y.length > 0) {
        if (!maxVal) maxVal = courbe.y[0];
        if (!minVal) minVal = courbe.y[0];

        for (const val of courbe.y) {
          if (val > maxVal) maxVal = val;
          if (val < minVal) minVal = val;
        }

        if (courbe.yaxis === 'y1') {
          currentValue = courbe.y[courbe.y.length - 1];
          currentUnit = courbe.engineering_unit;
          currentLabel = courbe.name;
          currentColor = courbe.color;
        }
      }
    }

    return {
      value: currentValue,
      unit: currentUnit,
      label: currentLabel,
      color: currentColor,
      maxValue: maxVal,
      minValue: minVal,
    };
  }, [donnees]);

  // Style configurations
  const styleConfigs = useMemo(() => {
    const jsonLayout = viewobj_json_content?.layout || {};
    const styleData = viewobj_json_content?.styleData || {};
    const styleDataGauge = styleData.gauge || {};
    const styleDataGaugeAxis = styleData.gauge?.axis || {};
    const styleDataGaugeAxisRange = styleData.gauge?.axis?.range || [];

    return {
      jsonLayout,
      styleData,
      styleDataGauge,
      styleDataGaugeAxis,
      styleDataGaugeAxisRange,
    };
  }, [viewobj_json_content]);

  // Plot data configuration
  const data = [
    {
      type: 'indicator',
      mode: 'gauge+number',
      value: value,
      title: {
        text: `${configuration.title}<br>${configuration.subtitle}`,
        align: 'left',
        font: { size: 24 },
      },
      number: {
        font: { size: 120 },
        suffix: ` ${unit}`,
      },
      ...styleConfigs.styleData,
      gauge: {
        bar: {
          color: color,
          thickness: 1,
        },
        borderwidth: 2,
        bordercolor: 'gray',
        ...styleConfigs.styleDataGauge,
        axis: {
          tickwidth: 1,
          tickcolor: 'gray',
          tickfont: { size: 40 },
          ...styleConfigs.styleDataGaugeAxis,
          range: [
            styleConfigs.styleDataGaugeAxisRange[0] ?? minValue,
            styleConfigs.styleDataGaugeAxisRange[1] ?? maxValue,
          ],
        },
      },
    },
  ];

  const layout = {
    responsive: true,
    width: dimensionWidth || window.innerWidth * 0.75,
    height: dimensionHeight || window.innerHeight * 0.75,
    font: {
      color: 'gray',
      family: 'Opensans',
      fontSize: 150,
    },
    margin: {
      t: 130,
      b: 130,
      l: 130,
      r: 130,
    },
    ...styleConfigs.jsonLayout,
  };

  const config = {
    locales: { fr: localeDictionary },
    locale: 'fr',
    displayModeBar:
      !viewobj_json_content ||
      viewobj_json_content.length === 0 ||
      viewobj_json_content.displayModeBar === true,
    displaylogo: false,
    modeBarButtonsToRemove: [''],
  };

  return (
    <BibliothequePlotly
      layout={layout}
      donneesGraphe={donneesGraphe}
      ouvrirPopupModifierIntervalle={switchAfficherModifierIntervalle}
      dimensionWidth={dimensionWidth}
      dimensionHeight={dimensionHeight}
      viewobj_json_content={viewobj_json_content}
      data={data}
      config={config}
    />
  );
};

export default GaugeDemiCercle;
